require('./bootstrap');

$.npce = {};

require('./helpers');

$.npce.comments = {
    init_submits: function(model, target) {
        $("#"+model+"_"+target+"_comment_list form").submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var comment = $(this).find('.comment-area').val();
            if(comment.trim() != '') {
                $.ajax({
                    type: "POST",
                    url: form.attr('action'),
                    data: form.serialize(),
                    success: function (response) {
                        $(response.html).insertBefore(form.parent().parent().children('a.small')).effect("highlight", {color: "#aaffaa"},  3000);
                        $('#'+model+'_'+target+'_comment_form form .comment-area').val('');
                        if(response.hasOwnProperty('model') && response.hasOwnProperty('target')) {
                            $.npce.comments.init_submits(response.model, response.target);
                        }
                    }
                }).done( function() {
                    $.npce.comments.hide_show_things();
                    $.npce.comments.init_delete(model, target);
                });
            } else {
                $.npce.comments.hide_show_things();
                return false;
            }
        });
    },
    init_delete: function(model,target) {
        $("#"+model+"_"+target+"_comment_list a.delete-link").click(function(e) {
            e.preventDefault();
            var link = $(this);
            var comment_container = link.parent().parent();
            if( confirm("Haluatko varmasti poistaa kommentin? Are you sure you want to delete comment?")) {
                $.ajax({
                    type: "POST",
                    url: '/comments/'+comment_container.data('comment-id')+'/delete',
                    data: {'_METHOD': 'DELETE', '_token': window.Laravel.csrfToken},
                    success: function (response) {
                        link.parent().parent().hide();
                    }
                });
            }
            return false;
        });
    },
    hide_show_things: function() {
        $('.comments a.small').show();
        $('.comments a.small').last().hide();
        $('.comment_form_container:not(:last)').collapse("hide");
        $('.comments a.small').click(function() { $(this).hide(); });
        $('.comment_form_container').last().stop().collapse("show");
    }
};